import { NavigationGroup } from "../types/navigation.types";

export const navigationGroups: NavigationGroup[] = [
    {
        title: "Обзор",
        items: [
            {
                label: "Dashboard",
                path: "/",
            },
            {
                label: "Заказы",
                path: "/orders",
            },
            {
                label: "Абонементы",
                path: "/subscriptions",
            },
            {
                label: "Гастрольные туры",
                path: "/tours",
            },
            {
                label: "Промокоды",
                path: "/promo-codes",
            },
            {
                label: "Скидки",
                path: "/discounts",
            },
            // {
            //     label: "Купоны",
            //     path: "/coupons",
            // },
        ],
    },
    {
        title: "Контент",
        items: [
            {
                label: "Текстовые страницы",
                path: "/content/text-pages",
            },
            {
                label: "Слайдшоу",
                path: "/content/slideshows",
            },
            {
                label: "SEO",
                path: "/content/seo",
            },
            {
                label: "Статьи",
                path: "/content/articles",
            },
            {
                label: "Настройки",
                path: "/content/settings",
            },
        ],
    },
    {
        title: "Справочники",
        items: [
            {
                label: "Категории событий",
                path: "/directory/categories",
            },
            {
                label: "Типы цен",
                path: "/directory/price-types",
            },
            {
                label: "Категории артистов",
                path: "/directory/artist-categories",
            },
            {
                label: "Артисты",
                path: "/directory/artists",
            },
            {
                label: "Залы",
                path: "/directory/halls",
            },
            {
                label: "Страны и города",
                path: "/directory/geo",
            },
            {
                label: "Организаторы",
                path: "/directory/organizers",
            },
            // {
            //     label: "Схемы залов",
            //     path: "/hall-schemes",
            // },
        ],
    },
    {
        title: "Пользователи",
        items: [
            {
                label: "Пользователи",
                path: "/users",
            },
            {
                label: "API-распространители",
                path: "/api-distributors",
            },
            // {
            //     label: "Партнеры",
            //     path: "/partners",
            // },
        ],
    },
    {
        title: "Статистика",
        items: [
            {
                label: "Общая статистика",
                path: "/statistics/general",
            },
            // {
            //     label: "Туры и города",
            //     path: "/statistics",
            // },
            // {
            //     label: "Распространители",
            //     path: "/statistics/distributors",
            // },
            // {
            //     label: "Заказы через API",
            //     path: "/statistics/api-orders",
            // },
        ],
    },
];
